module.exports = __webpack_public_path__ + "assets/97c4af571ce82b35471eef5e85431636.woff2";